import { render, staticRenderFns } from "./IsDark.vue?vue&type=template&id=4b3a2d62&scoped=true&"
import script from "./IsDark.vue?vue&type=script&lang=js&"
export * from "./IsDark.vue?vue&type=script&lang=js&"
import style0 from "./IsDark.vue?vue&type=style&index=0&id=4b3a2d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a2d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
